var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:'img-' + _vm.id,staticClass:"lazy-image",attrs:{"id":'img-' + _vm.id,"data-src":_vm.src,"src":_vm.realSrc || _vm.loadingImage}})}
var staticRenderFns = []

export { render, staticRenderFns }